export const CONFIG_CHANGE = 'CONFIG_CHANGE';
